export const hotTableLicenseKey = "0b014-a057a-62a00-d4631-40c07";
export const messages = {
    LOADING_DATA: "Please wait. Loading data.",
    REFRESHING_DATA: "Please wait. Refreshing the data.",
    ONLY_IMPORT: "I am importing clients from another system, you cannot add clients directly into CCH Axcess™ Workflow.",
    ALREADY_EXISTS: "Client name already exists. Add middle initial, suffix or client account number to distinguish from existing client.",
    VALID_CLIENT_DETAILS: "Please enter valid client details",
    INVALID_REQUEST: "Request is invalid ",
};